import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  switch(event) {
    const lang = event.currentTarget.dataset.locale || event.currentTarget.dataset.lang
    const url = new URL(window.location.href)
    url.searchParams.set('locale', lang)
    window.location.href = url.toString()
  }
}
